import clsx from 'clsx';
import React from 'react';

interface SectionBlockProps {
  children: React.ReactNode;
  title?: string;
  variant?: 'primary' | 'secondary';
  className?: string;
  skipContentContainer?: boolean;
  headerContent?: React.ReactNode;
}

export function SectionBlock({
  children,
  title,
  variant = 'primary',
  className,
  skipContentContainer = false,
  headerContent,
}: SectionBlockProps): JSX.Element {
  const baseStyles = {
    title: 'font-nunito',
  };

  const variantStyles = {
    primary: {
      wrapper: 'rounded-lg border border-border-gray bg-surface-0 p-6 my-6 ',
      title: 'text-2xl font-nunito font-[400] leading-7 text-gray-900 ',
      content: 'bg-white rounded-lg p-4',
    },
    secondary: {
      wrapper: 'w-full p-3 flex flex-col flex-wrap gap-4 bg-inherit',
      title: 'text-xl font-regular font-nunito leading-7 text-title',
      content:
        'flex flex-col justify-center items-center p-6 gap-2 flex-1 self-stretch rounded-lg border border-dashed border-gray-light bg-surface-0',
    },
  };

  return (
    <div className={clsx(variantStyles[variant].wrapper, className)}>
      {(title || headerContent) && (
        <div className="flex items-center gap-4 mb-6">
          {title && (
            <h2
              className={clsx(baseStyles.title, variantStyles[variant].title)}
            >
              {title}
            </h2>
          )}
          {headerContent && <div>{headerContent}</div>}
        </div>
      )}
      {!skipContentContainer ? (
        <div className={variantStyles[variant].content}>{children}</div>
      ) : (
        children
      )}
    </div>
  );
}
